<svg xmlns="http://www.w3.org/2000/svg" width="18" height="19" fill="none" viewBox="0 0 18 19">
    <g>
        <path fill="#FFFFFF" d="M9 5a2.812 2.812 0 1 0 0 5.625A2.812 2.812 0 0 0 9 5Zm0 4.5a1.687 1.687 0 1 1 0-3.375A1.687 1.687 0 0 1 9 9.5Zm0-7.875a6.195 6.195 0 0 0-6.188 6.188c0 2.207 1.02 4.547 2.954 6.767a17.87 17.87 0 0 0 2.914 2.693.562.562 0 0 0 .646 0 17.876 17.876 0 0 0 2.908-2.693c1.93-2.22 2.954-4.56 2.954-6.768A6.195 6.195 0 0 0 9 1.625Zm0 14.484c-1.162-.914-5.063-4.271-5.063-8.297a5.063 5.063 0 1 1 10.126 0c0 4.024-3.9 7.383-5.063 8.297Z"/>
    </g>
    <defs>
    </defs>
</svg>
